import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { getData } from '../selectors/microdata';
import { getCustomAttributes } from '../selectors';
import { getHierarchies } from '../selectors/sdmx';
import {
  prepareTableColumns,
  prepareTableRows,
  getMissingRows,
} from '../lib/sdmx/microdata';
import useSdmxStructure from './useSdmxStructure';

export default () => {
  const data = useSelector(getData);
  const hierarchies = useSelector(getHierarchies);
  const customAttributes = useSelector(getCustomAttributes);

  const { automatedSelections } = useSdmxStructure();
  const columns = useMemo(() => {
    if (R.isNil(data)) {
      return [];
    }
    return prepareTableColumns(data, customAttributes);
  }, [data]);
  const rows = useMemo(() => {
    if (R.isNil(data)) {
      return [];
    }
    return R.pipe(
      prepareTableRows,
      R.reduce((acc, row) => {
        const missingRows = getMissingRows(row, R.last(acc), columns);
        return R.concat(acc, missingRows);
      }, []),
    )(data, hierarchies, automatedSelections);
  }, [data, hierarchies, automatedSelections]);

  return { rows, columns, count: rows.length };
};
